import { useTranslation } from "react-i18next";
import { IngredientLoadState } from "src/api/client-api/ingredients/useGetOneIngredient";
import { RemoteErrorAlert } from "src/components/PageState/RemoteErrorAlert";

type IngredientLoadStateErrorProps = {
    state: Exclude<IngredientLoadState, { status: "loading" } | { status: "success-value" }>;
    onRetry: () => void | Promise<unknown>;
};

export const IngredientLoadStateError = (props: IngredientLoadStateErrorProps) => {
    const { state, onRetry } = props;
    const { t } = useTranslation();

    const message = (() => {
        switch (state.status) {
            case "contract-error":
                return t("ingredient.contract_error", "Ingredient data is incomplete. Editing is disabled.");
            case "forbidden":
                return t("ingredient.error.forbidden", "You are forbidden from viewing this ingredient.");
            case "not-found":
                return t("ingredient.error.not_found", "This ingredient was not found.");
            case "server-error":
                return t("ingredient.error.server", "The ingredient could not be loaded. Please try again.");
        }
    })();

    return <RemoteErrorAlert message={message} onRetry={onRetry} status={state.status} />;
};
